import { FC } from 'react';
import { Skeleton } from 'tedooo-web-design-system/ui';

import './reviewsShopSkeleton.scss';
import ReviewSkeleton from './review/ReviewSkeleton';

const REVIEWS_SKELETON_COUNT = 4;

const ReviewsShopSkeleton: FC = () => {
  return (
    <div className="reviews-shop-skeleton-container">
      <div className="review-skeleton-summary-container skeleton-section">
        <Skeleton title className="review-shop-skeleton-title" />
        <div className="summary-text-container">
          {[...new Array(5)].map((_, index) => (
            <Skeleton title className="review-summary-skeleton-text" key={index} />
          ))}
        </div>
      </div>
      <div className="reviews-skeleton-content-container">
        <div className="reviews-skeleton-content skeleton-section">
          <Skeleton title className="reviews-shop-skeleton-title" />
          {[...new Array(REVIEWS_SKELETON_COUNT)].map((_, index) => (
            <ReviewSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReviewsShopSkeleton;
